import { createModuleStore } from '../utils'

export const usePermissionsStore = createModuleStore(
  'permissions',
  {
    type: 'Permission',
    pageHeading: 'Permissions',
    noHistory: true,
    sortingOn: 'toolbar',
    uri: '/permissions',
    serviceUri: '/permissions',
    uploadOptionsCsv: '',
    downloadOptionsCsv: '',
    noAdd: true,
    noEdit: true,
    noActivate: true,
    noDeactivate: true,
    noDelete: true,
    noTour: false,
    noSettings: true,
    noSearch: true,
    noSort: true,
    noProviderFiltering: true,
    noProviderPaging: true,
    noProviderSorting: true,
    noColumnSelection: true,
    statusesFilterName: 'statuses',
    listingModuleName: 'Access Control',
    listingActivityName: 'View Permissions',
    formModuleName: 'Access Control',
    formActivityName: 'Edit Permission',
    allFields: [{ key: 'name', title: 'PERMISSION', sortable: true, type: 'permissionName', className: 'size-5/12' }],
  },
  {},
  {},
  {}
)
